import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Scenes } from '../../../pages/scenes/Scenes';
import { getListScenesQueryOptions } from '../../../rest-api/queries/sharedQueries';

export const Route = createFileRoute('/_private/_home/scene')({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(getListScenesQueryOptions(context.apiClient));
  },
  component: ScenesRoute,
});

function ScenesRoute() {
  const { apiClient } = Route.useRouteContext();
  return <Scenes portalApiClient={apiClient} />;
}
